import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Timeline({ limit }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/timeline").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const shown = limit ? items.slice(0, limit) : items;

  return (
    <section
      id="trajetoria"
      data-testid="timeline-section"
      className="py-24 md:py-32 bg-[#FAF9F6] border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
              <span className="accent-line" />
              Trajetória política
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-neutral-900">
              Uma vida pública construída <em className="italic font-light">passo a passo</em>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg leading-relaxed text-neutral-600 font-light">
            Cada conquista a seguir é fruto de escuta, articulação e trabalho coletivo com a população
            de Lauro de Freitas — bairro por bairro, demanda por demanda.
          </p>
        </div>

        <ol className="relative border-l-2 border-neutral-300 ml-3 md:ml-6">
          {shown.map((it, idx) => (
            <li
              key={`${it.year}-${idx}`}
              data-testid={`timeline-item-${idx}`}
              className="relative pl-8 md:pl-12 pb-12 last:pb-0 reveal"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <span className="absolute -left-[9px] top-1 w-4 h-4 bg-[#FFC72C] border-2 border-[#003F88]" />
              <div className="grid md:grid-cols-12 gap-4 md:gap-8">
                <div className="md:col-span-3">
                  <div className="font-serif-display text-3xl md:text-4xl font-semibold text-[#003F88] leading-none">
                    {it.year}
                  </div>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-serif-display text-2xl md:text-3xl font-medium text-neutral-900 leading-tight">
                    {it.title}
                  </h3>
                  <p className="mt-3 text-base md:text-lg text-neutral-600 font-light leading-relaxed">
                    {it.text}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
